import { useMouse } from 'ahooks';
import { useHistory } from '@modern-js/runtime/router';
import classnames from 'classnames';
import { ReactElement, useRef } from 'react';
import styles from './index.module.less';
import BLUR from '@/assets/mengban.png';

interface ButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: ReactElement;
}

const Button: React.FC<ButtonProps> = ({ children, className, ...rest }) => {
  const ref = useRef<HTMLDivElement>(null);
  const state = useMouse(ref.current);
  const history = useHistory();
  const style = {
    '--x': state.elementX < 0 ? -128 : state.elementX,
    '--y': state.elementY < 0 ? -128 : state.elementY,
  } as React.CSSProperties;

  return (
    <div
      ref={ref}
      className={classnames(styles.button, className)}
      {...rest}
      style={style}
      onClick={() => history.replace('/support/concat')}
    >
      <span style={{ position: 'relative', zIndex: 1 }}>{children}</span>
      <div
        className={styles.blur}
        style={{ backgroundImage: `url(${BLUR})` }}
      />
    </div>
  );
};

export default Button;
